import { InjectionToken, Provider } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from '../../../environments/environment';

export enum ScreenLayout {
  mobile = 'mobile',
  desktop = 'desktop'
}

export const SCREEN_LAYOUT = new InjectionToken<ScreenLayout>('Detected screen layout on app start-up');

export const SCREEN_LAYOUT_PROVIDER: Provider = {
  provide: SCREEN_LAYOUT,
  deps: [DeviceDetectorService],
  useFactory: (deviceDetector: DeviceDetectorService) => {
    if (environment.runAsStandaloneApplication) {
      // On android terminal, custom user agent is used, so detector can not detect layout
      return ScreenLayout.mobile;
    }

    const userAgent = window.navigator.userAgent || '';
    // Custom mobile build with custom user agent
    if (userAgent.includes('VersaPOS')) {
      return ScreenLayout.mobile;
    }

    try {
      const isMobileOrTablet = deviceDetector.isTablet() || deviceDetector.isMobile();
      return isMobileOrTablet ? ScreenLayout.mobile : ScreenLayout.desktop;
    } catch (e) {
      // Log error, but do not terminate app
      console.error('Error while detecting screen layout:', e);
      return ScreenLayout.mobile;
    }
  }
};
